/**
 * Amber hazard line for uploads that still live only in the legacy models (they are
 * not in the documents framework, so they are counted here, never listed as cards),
 * with a link to the Documents tab's "Legacy uploads" section, where every one of
 * them is listed, downloadable and convertible.
 */
export function LegacyUploadsNote({
  summary,
  onOpenDocuments,
  'data-testid': testId,
}: {
  /** What is over there, e.g. "COI uploads not yet in Documents: 1 on file." */
  summary: React.ReactNode;
  /** Switches the drawer to the Documents tab (the host owns the tab state). */
  onOpenDocuments: () => void;
  'data-testid': string;
}) {
  return (
    <div
      className="tw:flex tw:flex-wrap tw:items-center tw:gap-x-1.5 tw:text-xs tw:text-amber-700"
      data-testid={testId}
    >
      <i className="fas fa-triangle-exclamation" aria-hidden="true" />
      <span>{summary}</span>
      <button
        type="button"
        className="tw:underline tw:hover:text-amber-800"
        onClick={onOpenDocuments}
        data-testid={`${testId}-link`}
      >
        See Legacy uploads on the Documents tab
      </button>
    </div>
  );
}
